import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BaseComponent } from "../../core/base.component";
import { SessionService } from "../../shared/services/session.service";
import { UserData } from "src/app/shared/models/user.model";
import { MediaMatcher } from "@angular/cdk/layout";
import { AuthService } from "@auth0/auth0-angular";
import { Router } from "@angular/router";
import { StringHelpers } from "src/app/shared/helpers/string-helpers";
import { OrganizationService } from "src/app/shared/services/identity/organization.service";
import { AlertModalComponent } from "src/app/shared/modals/alert-modal/alert-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { GlobalDataService } from "src/app/shared/services/global-data.service";

@Component({
    selector: "simbook-layout",
    templateUrl: "./postLogin-simbook-layout.component.html",
    styleUrls: ["../layout.component.scss"],
    standalone: false
})
export class PostLoginSimBookLayoutComponent extends BaseComponent implements OnInit {
  public user: UserData = new UserData();
  public isDarkTheme = false;
  public toggled: boolean = true;

  private _mobileQueryListener: () => void
  mobileQuery: MediaQueryList;

  constructor(sessionService: SessionService,
    private authService: AuthService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    stringHelpers: StringHelpers,
    private organizationService: OrganizationService,
    private dialog: MatDialog,
    private globalDataService: GlobalDataService
  ) {
    super(sessionService, stringHelpers);
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.user = this.getUserFromSession();
    this.organizationService.getOrganizationById(this.user.organizationId).subscribe((res: any) => {
      if(res.stripeAccountId === null){
        if(this.router.url.includes('my-account')){
          return;
        }

        const dialogRef = this.dialog.open(AlertModalComponent, {
          width: '35vw'
        });
        dialogRef.componentInstance.title = "Account Setup";
        dialogRef.componentInstance.body = "In order to accept payments, please fill out the Organization Section and add a Payment Method under My Account. This will also include the Stripe Onboarding process. You will be redirected after clicking Okay.";
        dialogRef.componentInstance.submitText = "Okay";


        dialogRef.afterClosed().subscribe({
          next: () => {
            this.router.navigate(['/simulator-management/simulator-booking/my-account']);
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  isDefaultTheme() {
    if (!this.user.defaultTheme) {
      document.body.classList.remove('dark-mode');
      this.isDarkTheme = false;
      this.user.defaultTheme = true;
      this.sessionService.setUser(this.user);
    } else {
      document.body.classList.add('dark-mode');
      this.isDarkTheme = true;
      this.user.defaultTheme = false;
      this.sessionService.setUser(this.user);
    }
  }

  onToggleChange(event: any) {
    if (event.checked) {
      document.body.classList.add('dark-mode');           
      this.isDarkTheme = true;
      this.user.defaultTheme = false;
      this.sessionService.setUser(this.user);
      this.globalDataService.themeChangeEvent.emit(true);
    } else {
      document.body.classList.remove('dark-mode');
      this.isDarkTheme = false;
      this.user.defaultTheme = true;
      this.sessionService.setUser(this.user);
      this.globalDataService.themeChangeEvent.emit(false);
    }
  }

  logout(){
    this.sessionService.removeUser();
    this.user = new UserData();
    this.router.navigate(["/callback"]);
    this.authService.logout();
  }

}